import React, { useState } from 'react';

import {
  Box,
  Typography
} from '@mui/material';

import EditOrganizationModal from './EditOrganizationModal';
import OrganizationInfoCard from './OrganizationInfoCard';
import PracticeInformationCard from './PracticeInformationCard';
import PracticeInformationModal from './PracticeInformationModal';

import {
  organizationInfo as initialOrganizationInfo,
  practiceRows as initialPracticeRows
} from './data';

import { pageTitleSx } from './styles';

const OrganizationProfile = () => {
  const [organizationInfo, setOrganizationInfo] = useState(
    initialOrganizationInfo
  );

  const [practices, setPractices] = useState(initialPracticeRows);
  const [openEditOrganization, setOpenEditOrganization] = useState(false);
  const [openPracticeModal, setOpenPracticeModal] = useState(false);
  const [practiceModalMode, setPracticeModalMode] = useState('add');
  const [selectedPractice, setSelectedPractice] = useState(null);

  const handleOpenOrganizationModal = () => {
    setOpenEditOrganization(true);
  };

  const handleCloseOrganizationModal = () => {
    setOpenEditOrganization(false);
  };

  const handleSaveOrganization = updatedData => {
    setOrganizationInfo(updatedData);
    setOpenEditOrganization(false);
  };

  const handleAddPractice = () => {
    setPracticeModalMode('add');
    setSelectedPractice(null);
    setOpenPracticeModal(true);
  };

  const handleEditPractice = practice => {
    setPracticeModalMode('edit');
    setSelectedPractice(practice);
    setOpenPracticeModal(true);
  };

  const handleClosePracticeModal = () => {
    setOpenPracticeModal(false);
    setSelectedPractice(null);
  };

  const handleSavePractice = practiceData => {
    if (practiceModalMode === 'edit' && selectedPractice) {
      setPractices(previousPractices =>
        previousPractices.map(practice =>
          practice.id === selectedPractice.id
            ? {
                ...practice,
                ...practiceData
              }
            : practice
        )
      );
    } else {
      setPractices(previousPractices => [
        ...previousPractices,
        {
          ...practiceData,
          id: Date.now()
        }
      ]);
    }

    handleClosePracticeModal();
  };

  const handleDeletePractice = practice => {
    setPractices(previousPractices =>
      previousPractices.filter(item => item.id !== practice.id)
    );
  };

  return (
    <Box sx={{
      p: 1,
      width: '100%'
    }}>
      <Typography sx={pageTitleSx}>
        View/Manage Organization Profile
      </Typography>

      <OrganizationInfoCard
        data={{
          ...organizationInfo,
          billingAddress: `${organizationInfo.billingStreet}, ${organizationInfo.city}, ${organizationInfo.state} ${organizationInfo.zip}`
        }}
        onEdit={handleOpenOrganizationModal}
      />

      <PracticeInformationCard
        onAdd={handleAddPractice}
        onDelete={handleDeletePractice}
        onEdit={handleEditPractice}
        rows={practices}
      />

      <EditOrganizationModal
        data={organizationInfo}
        onClose={handleCloseOrganizationModal}
        onSave={handleSaveOrganization}
        open={openEditOrganization}
      />

      <PracticeInformationModal
        mode={practiceModalMode}
        onClose={handleClosePracticeModal}
        onSubmit={handleSavePractice}
        open={openPracticeModal}
        practice={selectedPractice}
      />
    </Box>
  );
};

export default OrganizationProfile;